import { render, staticRenderFns } from "./demand-add-or-update.vue?vue&type=template&id=70a190c8&scoped=true"
import script from "./demand-add-or-update.vue?vue&type=script&lang=js"
export * from "./demand-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./demand-add-or-update.vue?vue&type=style&index=0&id=70a190c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a190c8",
  null
  
)

export default component.exports